import { get, post, put } from "../../../utils/axios-config";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { KNOWLEDGE_SUBDOMAINS } from "../../../utils/constants";
import { KnowledgeSubDomainType } from "../../../types/KnowledgeDomain";

export const createKnowledgeSubDomain = async (data: KnowledgeSubDomainType) => {
    return await post<KnowledgeSubDomainType, string>(KNOWLEDGE_SUBDOMAINS, data);
};

export const updateKnowledgeSubDomain = async (data: KnowledgeSubDomainType) => {
    return await put<KnowledgeSubDomainType, string>(KNOWLEDGE_SUBDOMAINS, data);
};

export const getKnowledgeSubDomains = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.DomainId ? { DomainId: data.DomainId } : {}),

    });
    
    const url = `${KNOWLEDGE_SUBDOMAINS}?${queryParams.toString()}`;
    return await get<PagedResultsType<KnowledgeSubDomainType>>(url);
};

// export const getKnowledgeSubDomainsByDomain = async (domainId: string) => {
//     return await get<PagedResultsType<KnowledgeSubDomainType>>(`${KNOWLEDGE_SUBDOMAINS_BY_DOMAIN}/${domainId}`);
// };
